var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { md: "12" } },
        [
          _c(
            "card",
            { staticClass: "stacked-form" },
            [
              _vm.isLoading
                ? _c("l-progress", {
                    staticClass: "mb-2",
                    attrs: {
                      value: 100,
                      height: 20,
                      type: "info",
                      animated: true,
                      striped: true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row mb-5" },
                [
                  _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c("h4", { staticClass: "mb-3" }, [
                        _c("strong", [_vm._v("Data Order")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "4" } }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Kode")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "8" } }, [
                            _c("span", [_vm._v(_vm._s(_vm.model.code))])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "4" } }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Status")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "8" } }, [
                            _c(
                              "span",
                              [
                                _c(
                                  "b-badge",
                                  {
                                    attrs: {
                                      variant: _vm.getStatusColor(
                                        _vm.model.status
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.getStatus(_vm.model.status))
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "4" } }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Disablon")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "8" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.is_sablon === 0 ? "Tidak" : "Ya"
                                )
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.model.is_sablon !== 0
                        ? [
                            _c(
                              "b-row",
                              [
                                _c("b-col", { attrs: { md: "4" } }, [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v("Jenis Sablon")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { md: "8" } }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.model.sablon.title))
                                  ])
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c("b-col", { attrs: { md: "4" } }, [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v("Harga Sablon")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { md: "8" } }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(
                                          _vm.model.sablon_selling_price
                                        )
                                      )
                                    )
                                  ])
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c("b-col", { attrs: { md: "4" } }, [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v("Kuantitas Sablon")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { md: "8" } }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.model.sablon_quantity))
                                  ])
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c("b-col", { attrs: { md: "4" } }, [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v("Harga Total Sablon")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { md: "8" } }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(_vm.model.sablon_total)
                                      )
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.model.status === 0
                        ? [
                            _c(
                              "b-row",
                              [
                                _c("b-col", { attrs: { md: "4" } }, [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v("Down Payment")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { md: "8" } }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(_vm.model.down_payment)
                                      )
                                    )
                                  ])
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c("b-col", { attrs: { md: "4" } }, [
                                  _c("label", { attrs: { for: "" } }, [
                                    _vm._v("Remaing Payment")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("b-col", { attrs: { md: "8" } }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatNumber(
                                          _vm.model.remaining_payment
                                        )
                                      )
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "4" } }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Dibuat Oleh")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "8" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.model.created_by.name))
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "4" } }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Diperbaharui Oleh")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "8" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.model.last_updated_by.name))
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "6" } },
                    [
                      _c("h4", { staticClass: "mb-3" }, [
                        _c("strong", [_vm._v("Data Pelanggan")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "4" } }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Nama")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "8" } }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.model.customer.name))
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "4" } }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Kategori")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "8" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.customer.customer_category.name
                                )
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "4" } }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Alamat")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "8" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.customer.address !== null
                                    ? _vm.model.customer.address
                                    : "-"
                                )
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "4" } }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Email")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "8" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.customer.email !== null
                                    ? _vm.model.customer.email
                                    : "-"
                                )
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "4" } }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("No. Telp")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "8" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.customer.phone !== null
                                    ? _vm.model.customer.phone
                                    : "-"
                                )
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "4" } }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v("Terdaftar Tgl")
                            ])
                          ]),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "8" } }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getDate(
                                    _vm.model.customer.registered_date
                                  )
                                )
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { md: "6 mb-2" } }, [
                            _c("h3", { staticClass: "m-0" }, [
                              _c("strong", [_vm._v("Detail Order")])
                            ])
                          ]),
                          _vm._v(" "),
                          _vm.model.status === 2
                            ? _c(
                                "b-col",
                                { attrs: { md: "6 text-right mb-2" } },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: _vm.addProduct
                                          ? "warning"
                                          : "primary"
                                      },
                                      on: {
                                        click: function($event) {
                                          _vm.addProduct = !_vm.addProduct
                                        }
                                      }
                                    },
                                    [
                                      _vm.addProduct
                                        ? _c("font-awesome-icon", {
                                            attrs: { icon: "times" }
                                          })
                                        : _c("font-awesome-icon", {
                                            attrs: { icon: "plus" }
                                          }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.addProduct
                                              ? "Batal"
                                              : "Tambah Item"
                                          ) +
                                          " "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.addProduct && _vm.model.status === 2
                        ? [
                            _c(
                              "form",
                              {
                                on: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                    return _vm.doSubmit($event)
                                  }
                                }
                              },
                              [
                                _vm._l(_vm.lines, function(line, index) {
                                  return _c(
                                    "b-row",
                                    {
                                      key: index,
                                      staticClass: "border ml-0 mr-0 mb-3 mt-3"
                                    },
                                    [
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { md: "5" } },
                                          [
                                            _c(
                                              "fg-input",
                                              { attrs: { label: "Produk" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group input-typeahead",
                                                    class:
                                                      _vm.productError !== null
                                                        ? "has-error"
                                                        : ""
                                                  },
                                                  [
                                                    _c("typeahead", {
                                                      ref:
                                                        "userProfileUuidTypeahead",
                                                      refInFor: true,
                                                      attrs: {
                                                        customQueryParamName:
                                                          "name",
                                                        disabled: true,
                                                        labelFields: ["name"],
                                                        placeholder:
                                                          "Cari Product",
                                                        urlSearch:
                                                          _vm.apiUrl
                                                            .productSearch,
                                                        "arr-response": "data",
                                                        model: line.product,
                                                        formType:
                                                          "productSearch"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.productError !== null
                                                      ? _c("p", {
                                                          staticClass: "error",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.productError
                                                            )
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "3" } },
                                          [
                                            _vm.model.customer.customer_category
                                              .name === "Sepesial Member" &&
                                            Object.keys(line.product).length > 0
                                              ? _c(
                                                  "fg-input",
                                                  { attrs: { label: "Harga" } },
                                                  [
                                                    _c(
                                                      "p",
                                                      { staticClass: "pt-2" },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              line.product
                                                                .sellingPrice >
                                                              0
                                                                ? _vm.formatNumber(
                                                                    line.product
                                                                      .smPrice *
                                                                      line.quantity
                                                                  )
                                                                : 0
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm.model.customer
                                                  .customer_category.name ===
                                                  "Member" &&
                                                Object.keys(line.product)
                                                  .length > 0
                                                ? _c(
                                                    "fg-input",
                                                    {
                                                      attrs: { label: "Harga" }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        { staticClass: "pt-2" },
                                                        [
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(
                                                                line.product
                                                                  .sellingPrice >
                                                                0
                                                                  ? _vm.formatNumber(
                                                                      line
                                                                        .product
                                                                        .memberPrice *
                                                                        line.quantity
                                                                    )
                                                                  : 0
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : (_vm.lines.length > 2 &&
                                                    _vm.lines.length <= 11) ||
                                                  (line.quantity > 2 &&
                                                    line.quantity <= 11 &&
                                                    (_vm.model.customer
                                                      .customer_category
                                                      .name !== "Member" ||
                                                      _vm.model.customer
                                                        .customer_category
                                                        .name !==
                                                        "Sepesial Member") &&
                                                    Object.keys(line.product)
                                                      .length > 0)
                                                  ? _c(
                                                      "fg-input",
                                                      {
                                                        attrs: {
                                                          label: "Harga"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass: "pt-2"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  line.product
                                                                    .sellingPrice >
                                                                  0
                                                                    ? _vm.formatNumber(
                                                                        line
                                                                          .product
                                                                          .more3 *
                                                                          line.quantity
                                                                      )
                                                                    : 0
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm.lines.length > 11 ||
                                                    (line.quantity > 11 &&
                                                      (_vm.model.customer
                                                        .customer_category
                                                        .name !== "Member" ||
                                                        _vm.model.customer
                                                          .customer_category
                                                          .name !==
                                                          "Sepesial Member") &&
                                                      Object.keys(line.product)
                                                        .length > 0)
                                                    ? _c(
                                                        "fg-input",
                                                        {
                                                          attrs: {
                                                            label: "Harga"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "pt-2"
                                                            },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    line.product
                                                                      .sellingPrice >
                                                                    0
                                                                      ? _vm.formatNumber(
                                                                          line
                                                                            .product
                                                                            .more12 *
                                                                            line.quantity
                                                                        )
                                                                      : 0
                                                                  )
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : Object.keys(line.product)
                                                        .length > 0
                                                      ? _c(
                                                          "fg-input",
                                                          {
                                                            attrs: {
                                                              label: "Harga"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "pt-2"
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.formatNumber(
                                                                        line
                                                                          .product
                                                                          .sellingPrice *
                                                                          line.quantity
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { attrs: { md: "2" } },
                                          [
                                            _c("fg-input", {
                                              attrs: {
                                                label: "Kuantitas",
                                                min: "1",
                                                type: "number"
                                              },
                                              model: {
                                                value: line.quantity,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    line,
                                                    "quantity",
                                                    $$v
                                                  )
                                                },
                                                expression: "line.quantity"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            attrs: {
                                              md: "1 mt-4-5 text-center"
                                            }
                                          },
                                          [
                                            index >= 1 &&
                                            _vm.$route.params.id === undefined
                                              ? _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-danger",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.removeLine(index)
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-times"
                                                    })
                                                  ]
                                                )
                                              : _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-danger",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.removeLine(index)
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-times"
                                                    })
                                                  ]
                                                )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          {
                                            attrs: {
                                              md: "1 mt-4-5 text-center"
                                            }
                                          },
                                          [
                                            index + 1 === _vm.lines.length
                                              ? _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      type: "button",
                                                      variant: "primary"
                                                    },
                                                    on: { click: _vm.addLine }
                                                  },
                                                  [
                                                    _c("font-awesome-icon", {
                                                      attrs: { icon: "plus" }
                                                    })
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    ],
                                    2
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c("fg-input", {
                                          attrs: {
                                            label: "Diskon",
                                            type: "number"
                                          },
                                          model: {
                                            value: _vm.model.diskon,
                                            callback: function($$v) {
                                              _vm.$set(_vm.model, "diskon", $$v)
                                            },
                                            expression: "model.diskon"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c("fg-input", {
                                          attrs: {
                                            label: "PPN (%)",
                                            type: "number"
                                          },
                                          model: {
                                            value: _vm.model.ppn,
                                            callback: function($$v) {
                                              _vm.$set(_vm.model, "ppn", $$v)
                                            },
                                            expression: "model.ppn"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "fg-input",
                                          { attrs: { label: "Mau disablon?" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              [
                                                _c("b-form-radio-group", {
                                                  attrs: {
                                                    id: "isSablon",
                                                    options: _vm.optionsSablon,
                                                    name: "radio-sablon"
                                                  },
                                                  model: {
                                                    value: _vm.model.is_sablon,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.model,
                                                        "is_sablon",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "model.is_sablon"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.model.is_sablon === 1
                                  ? _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "4" } },
                                          [
                                            _c(
                                              "fg-input",
                                              { attrs: { label: "Sablon" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-group input-typeahead",
                                                    class:
                                                      _vm.sablonError !== null
                                                        ? "has-error"
                                                        : ""
                                                  },
                                                  [
                                                    _c("typeahead", {
                                                      ref:
                                                        "userProfileUuidTypeahead",
                                                      attrs: {
                                                        customQueryParamName:
                                                          "title",
                                                        labelFields: ["title"],
                                                        placeholder:
                                                          "Cari Sablon",
                                                        urlSearch:
                                                          _vm.apiUrl.sablon,
                                                        "arr-response": "data",
                                                        model:
                                                          _vm.model.sablon_id
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _vm.sablonError !== null
                                                      ? _c("p", {
                                                          staticClass: "error",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              _vm.sablonError
                                                            )
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "4" } },
                                          [
                                            _c(
                                              "fg-input",
                                              {
                                                attrs: {
                                                  label: "Harga Jual Sablon"
                                                }
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "pt-2" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatNumber(
                                                          _vm.model
                                                            .sablon_quantity *
                                                            _vm.model
                                                              .sablon_selling_price
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "4" } },
                                          [
                                            _c("fg-input", {
                                              attrs: {
                                                label: "Kuantitas",
                                                type: "number"
                                              },
                                              model: {
                                                value:
                                                  _vm.model.sablon_quantity,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.model,
                                                    "sablon_quantity",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "model.sablon_quantity"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-row",
                                  [
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "warning" },
                                            on: {
                                              click: function($event) {
                                                _vm.addProduct = !_vm.addLine
                                              }
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "times" }
                                            }),
                                            _vm._v(" Batal")
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-col",
                                      { attrs: { cols: "6" } },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "float-right",
                                            attrs: {
                                              variant: "primary",
                                              type: "submit"
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "save" }
                                            }),
                                            _vm._v(" Submit")
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "table-responsive mt-3" }, [
                        _c(
                          "table",
                          { staticClass: "table table-hoverd table-striped" },
                          [
                            _c("tr", [
                              _c("th", [_vm._v("Item")]),
                              _vm._v(" "),
                              _c("th", { staticClass: "text-right" }, [
                                _vm._v("Harga")
                              ]),
                              _vm._v(" "),
                              _c("th", { staticClass: "text-right" }, [
                                _vm._v("Kuantitas")
                              ]),
                              _vm._v(" "),
                              _c("th", { staticClass: "text-right" }, [
                                _vm._v("Total")
                              ]),
                              _vm._v(" "),
                              _vm.model.status === 2
                                ? _c("th", { staticClass: "text-right" })
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _vm.model.order_detail.length > 0
                              ? _c(
                                  "tbody",
                                  _vm._l(_vm.model.order_detail, function(
                                    orderDetail,
                                    index
                                  ) {
                                    return _c("tr", { key: orderDetail.id }, [
                                      _c("td", [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              orderDetail.product_size
                                                .product_color
                                                .product_categories.product.name
                                            ) +
                                            " - \n                    " +
                                            _vm._s(
                                              orderDetail.product_size
                                                .product_color
                                                .product_categories.category
                                                .name
                                            ) +
                                            " - \n                    " +
                                            _vm._s(
                                              orderDetail.product_size
                                                .product_color.color.name
                                            ) +
                                            " - \n                    " +
                                            _vm._s(
                                              orderDetail.product_size.size.name
                                            ) +
                                            "\n                  "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatNumber(
                                              orderDetail.selling_price
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "text-right" },
                                        [
                                          _vm.model.orderDetailId ===
                                          orderDetail.id
                                            ? [
                                                _c("fg-input", {
                                                  attrs: {
                                                    placeholder:
                                                      "Masukkan quantity",
                                                    min: "1",
                                                    type: "number"
                                                  },
                                                  model: {
                                                    value: orderDetail.quantity,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        orderDetail,
                                                        "quantity",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "orderDetail.quantity"
                                                  }
                                                })
                                              ]
                                            : [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      orderDetail.quantity
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatNumber(
                                              orderDetail.sub_total
                                            )
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm.model.status === 2
                                        ? _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm.model.orderDetailId ===
                                              orderDetail.id
                                                ? [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          variant: "danger"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.doReset(index)
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "times"
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          variant: "success"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.doEditOrderDetail(
                                                              orderDetail
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "check"
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : [
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          variant: "success"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.openEditOrderDetail(
                                                              orderDetail
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "pencil-alt"
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-button",
                                                      {
                                                        attrs: {
                                                          variant: "danger"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.doDeleteOrderDetail(
                                                              orderDetail.id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            attrs: {
                                                              icon: "trash"
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ])
                                  })
                                )
                              : _c("tbody", [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "text-center",
                                        attrs: { colspan: "7" }
                                      },
                                      [_vm._v("Tidak list item untuk saat ini")]
                                    )
                                  ])
                                ])
                          ]
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { md: "12" } }, [
                    _c("h3", { staticClass: "mb-5" }, [
                      _c("strong", [_vm._v("Riwayat Order")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "table",
                      { staticClass: "table table-hoverd table-striped" },
                      [
                        _c("tr", [
                          _c("th", [_vm._v("Dibuat Oleh")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Diperbaharui Oleh")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Status")]),
                          _vm._v(" "),
                          _c("th", [_vm._v("Tgl. Terbit")])
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.orderLogList, function(orderLog) {
                          return _c("tr", { key: orderLog.id }, [
                            _c("td", [
                              _vm._v(_vm._s(orderLog.created_by.name))
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(orderLog.last_updated_by.name))
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _c(
                                  "b-badge",
                                  {
                                    attrs: {
                                      variant: _vm.getStatusColor(
                                        orderLog.status
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.getStatus(orderLog.status))
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(orderLog.created_at))])
                          ])
                        })
                      ],
                      2
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("back-button")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bubble-info" },
        [
          _c(
            "b-button",
            {
              attrs: {
                href:
                  "https://posbackend.jaketdistromedan.com//invoice/" +
                  _vm.$route.params.id,
                variant: "secondary",
                download: ""
              }
            },
            [
              _c("font-awesome-icon", { attrs: { icon: "print" } }),
              _vm._v(" Cetak Invoice")
            ],
            1
          ),
          _vm._v(" "),
          parseInt(_vm.model.status) !== 1 && parseInt(_vm.model.status) !== 3
            ? _c(
                "b-button",
                {
                  attrs: { variant: "danger" },
                  on: {
                    click: function($event) {
                      _vm.doCancleOrder()
                    }
                  }
                },
                [
                  _c("font-awesome-icon", { attrs: { icon: "times" } }),
                  _vm._v(" Batalkan Order")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          parseInt(_vm.model.status) !== 1 && parseInt(_vm.model.status) !== 3
            ? _c(
                "b-button",
                {
                  attrs: { variant: "success" },
                  on: {
                    click: function($event) {
                      _vm.doApproveOrder()
                    }
                  }
                },
                [
                  _c("font-awesome-icon", { attrs: { icon: "check" } }),
                  _vm._v(" Setujui Order")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "btn btn-info" }, [
            _c("strong", [
              _vm._v(
                "Total : " +
                  _vm._s(_vm.formatNumber(_vm.model.total + _vm.totalSummary))
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36f5766a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36f5766a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/ProductFavorites/Show.vue
// module id = 97Vc
// module chunks = 4